import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import "./access.css";

const Login = ({ Data, SetData }) => {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const { error } = await signIn(loginData.email, loginData.password);
      if (error) throw error;

      SetData((prevData) => ({
        ...prevData,
        UserData: {
          ...prevData.UserData,
          email: loginData.email,
        },
        Access: "true",
      }));

      setLoginData({
        email: "",
        password: "",
      });
      scrollToTop();
      navigate("/account");
    } catch (err) {
      setError(err.message || "Failed to login.");
      setLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>ThinkTwiceOnline Store | LogIn</title>
        <meta name="description" content="ThinkTwiceOnline Store | LogIn" />
      </Helmet>
      <section id="access">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6">
              <img
                src="assets/images/banners/login.webp"
                alt="#"
                width="100%"
              />
            </div>
            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center mt-0 mt-lg-5 my-5 my-lg-0">
              <div>
                <h3>Login to ThinkTwiceOnline Store</h3>
                <p>Enter your details below</p>
                {error && <p className="text-danger">{error}</p>}
                <form onSubmit={handleSubmit} className="mt-4">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="d-block py-2 my-2"
                    placeholder="Email"
                    value={loginData.email}
                    onChange={(e) => {
                      setLoginData({
                        ...loginData,
                        email: e.target.value,
                      });
                    }}
                    required
                  />
                  <input
                    type="password"
                    id="password"
                    name="password"
                    className="d-block py-2 my-2"
                    placeholder="Password"
                    value={loginData.password}
                    onChange={(p) => {
                      setLoginData({
                        ...loginData,
                        password: p.target.value,
                      });
                    }}
                    required
                  />
                  <div className="mt-4 d-flex justify-content-between">
                    <button type="submit" className="py-1 px-3" id="CAbutton" disabled={loading}>
                      {loading ? "Logging in..." : "Log in"}
                    </button>
                    <span className="d-flex align-items-center">
                      <Link to="#"> Forget Password?</Link>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
